module.exports = __webpack_public_path__ + "img/nutrition-protein.365758f.svg";